export default __webpack_public_path__ + "static/media/more.b5190508.svg";